export default "__VITE_ASSET__BlsEdViL__"